import { AppError } from '../errors/AppError';
import type { IErrorCaptureContext, IErrorProvider } from '../errors/types';

function normalizeError(error: unknown): {
  name: string;
  message: string;
  code?: string;
  metadata?: Record<string, unknown>;
  cause?: unknown;
  stack?: string;
} {
  if (error instanceof AppError) {
    return {
      name: error.name,
      message: error.message,
      code: error.code,
      metadata: error.metadata,
      cause: error.cause,
      stack: error.stack,
    };
  }
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  return {
    name: 'UnknownError',
    message: String(error),
  };
}

export class ConsoleErrorProvider implements IErrorProvider {
  capture(error: unknown, context?: IErrorCaptureContext): void {
    console.error('[errors:capture]', normalizeError(error), context);
  }

  async flush(): Promise<void> {}

  async shutdown(): Promise<void> {}
}
